import React from "react";
import {connect} from "react-redux";
import MyTheme from "../../Theme/Theme";
import {View, Dimensions, Animated, TouchableOpacity, Text, Image, FlatList} from "react-native";
import Tabs from "../Menu/Tabs";
import {getContacts, getLastContent, getMyFocus} from "../../API/api-static";
import TendanceList from "../Tendance/TendanceList";
import TendancePopin from "../Tendance/TendancePopin";
import FiltrePicto from "../Picto/FiltrePicto";
import Logo, {BOLogo} from "../Picto/Logo";
import AvatarIcon from "../Header/AvatarIcon";
import {getTrendingAll} from "../../API/API";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import tendanceReducer from "../../Store/Reducers/tendanceReducer";

class TendanceScreen extends React.Component{

    constructor(props) {
        super(props);
        const contact = [];
        const Entity = [];
        const theme = [];
        this.state = {
            scrollX: new Animated.Value(0),
            activeTab : 0,
            data : [],
            contact : contact,
            Entity : Entity,
            theme : theme,
            isRefresh  : false,
            timeParution : 1,
            modalVisible : false
        }
        const feeds = {
            Contacts:
                {
                    Title : 'Contacts',
                    Feed: this.state.contact,
                    refresh : this._getContact,
                    avatar : true
                }
            ,
            Entity:
                {
                    Title : 'Entités',
                    Feed : this.state.Entity,
                    refresh : this._getEntity,
                    avatar : true
                },
            Theme:
                {
                    Title : 'Thèmes',
                    Feed : this.state.theme,
                    refresh : this._getTheme,
                    avatar : false
                }
        };
        this.feeds = feeds;
        this.data = Object.keys(feeds).map((i) => ({
            key: i,
            title: feeds[i].Title,
            feed : feeds[i].Feed,
            refresh : feeds[i].refresh,
            avatar : feeds[i].avatar,
            ref : React.createRef()
        }));

        this.setActiveTab = this.setActiveTab.bind(this);
        this.setModalVisible = this.setModalVisible.bind(this);
        this.setTimeParution = this.setTimeParution.bind(this);
        this.getData = this.getData.bind(this);
        this.getData();
        this.mref =React.createRef();
    }

    componentDidUpdate() {
        this._setHeader();
    }

    _setHeader(){
        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            borderWidth:0,
            elevation: 0,
            borderColor:"transparent" ,
            borderBottomWidth:0,
            backgroundColor : this.props.theme.colors.tertiary.grey3.value,
            height:80
        };



        this.props.navigation.setOptions(
            {
                headerTitle: () => (<View style={{flexDirection:'row',gap:10}}><Logo /><BOLogo /></View> ),
                headerStyle:styleHeaderGlobal,
                headerTitleAlign:"center",
                headerTitleStyle:{textTransform: 'capitalize'},
                cardStyle: {backgroundColor : this.props.theme.colors.tertiary.grey3.value},
                headerLeft : ()=>
                    (<TouchableOpacity
                        onPress={()=>{this.props.navigation.navigate('MyProfil',{})} }>
                        <AvatarIcon style={{width:35,height:35,borderWidth:0,borderRadius:14}}  isHeader={true} icon={this.props.auth.compte.img}/>
                    </TouchableOpacity>),
                headerRight : ()=>(
                    <TouchableOpacity onPress={()=>{this.setModalVisible(true);}}>
                        <FiltrePicto style={{width:20,height:17,flex : 1,marginRight:20 } } isHeader={true} />
                    </TouchableOpacity>)

            }
        );
    }

    updateTab(){
        this.data = Object.keys(this.feeds).map((i) => ({
            key: i,
            title: this.feeds[i].Title,
            image: this.feeds[i].Image,
            feed : this.feeds[i].Feed,
            refresh : this.feeds[i].refresh,
            loadMore : this.feeds[i].loadMore,
            ref : React.createRef()
        }));

        this.setState({
            data : this.data,
            isLoading: false
        });

        this.setActiveTab();
    }

    getDimensions() {
      return Dimensions.get('window');
    }

    onItemPress = (itemIndex) => {
        const { width } = this.getDimensions();

        this.mref.current.scrollToOffset({
            offset : itemIndex * width
        });
    }

    setActiveTab(){
        const { width } = this.getDimensions();

        let activeTab = Math.round(this.state.scrollX._value/width);
        this.setState({
            activeTab : activeTab
        });
    }

    setTimeParution(value){
        const action = {'type' :'CHANGE_TIME_PARUTION','value' : value};
        this.props.dispatch(action);

        this.getData(value);
    }

    _getContact(){
        return getContacts;
    }

    _getEntity(){
        return getContacts;
    }

    _getTheme(){
        return getContacts;
    }

    getData(timeParution = this.props.timeParution){
        getTrendingAll(timeParution).then(data=>{
            const contact = data.contact;
            const theme = data.theme;
            const Entity = data.entity;

            this.feeds.Contacts.Feed = contact;
            this.feeds.Entity.Feed = Entity;
            this.feeds.Theme.Feed = theme;

            this.updateTab();
        });
    }

    componentDidMount() {
        const { width } = this.getDimensions();

        this.setState({
            activeTab : width/this.state.scrollX || 0,
            data : this.data
        });

            this.props.navigation.setOptions({
                headerLeft : ()=>
                    <TouchableOpacity
                        onPress={()=>{this.props.navigation.navigate('MyProfil',{})} }>
                        <AvatarIcon style={{width:35,height:35,borderWidth:0,borderRadius:14}}  isHeader={true} icon={this.props.auth.compte.img}/>
                    </TouchableOpacity>,

            });
    }

    setModalVisible(value){
        this.setState({
            modalVisible : value
        })
    }

    render() {
        const { width, height } = this.getDimensions();



        const data = [1,7,30]

        const renderItem = (item) =>{
            const styleItem = {
                container: {
                    width:30,
                    height:30,
                    padding:5,
                    display:"flex",
                    justifyContent:"center",
                    marginHorizontal:5,
                    alignItems:"center",
                    borderRadius:"50%",
                    borderColor: this.props.theme.colors.primary.blue1.value,
                    backgroundColor: (this.props.timeParution==item)? this.props.theme.colors.primary.blue1.value:"transparent",
                },
                text:{
                    color : (this.props.timeParution!=item)? this.props.theme.colors.primary.blue1.value:"#fff",
                    fontSize:12,
                    fontFamily: this.props.theme.fonts.title
                }
            }
            return (<TouchableOpacity onPress={()=>{this.setModalVisible(true)}} style={styleItem.container}><Text style={styleItem.text}>{item + this.props.t('J')}</Text></TouchableOpacity>)
        };


        // <UserInactivity timeForInactivity={90000} onAction={() => {const action = {'type': 'SIGN_OUT_NIP', 'value':{}};this.props.dispatch(action);}} >
        return (<View>
                <View style={{flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
                    <Text style={{color:this.props.theme.colors.tertiary.black1.value,fontFamily:this.props.theme.fonts.title}}>{this.props.t('Durée de parution')} : </Text>
                    <View style={{display:"flex",flexDirection:"row",aligneItems:"center",marginRight:15}}>
                     <View style={{display:"flex",flexDirection:"row"}}>{renderItem(this.props.timeParution)}</View>
                    </View>
                </View>
                <Animated.FlatList
                    style={{marginTop:56,overflow:"scroll"}}
                    ref={this.mref}
                    data={this.data}
                    keyExtractor={item=>item.key}
                    horizontal={true}
                    showsHorizontalScrollIndicator={false}
                    pagingEnabled={true}
                    bounces={false}
                    onScroll={Animated.event([{nativeEvent :{contentOffset:{x:this.state.scrollX}}}],{listener :(event)=>{this.setActiveTab()} ,useNativeDriver:false})}
                    renderItem={(item)=>{
                        if(item.item.feed!==undefined && item.item.feed.length>0 ){
                            return <TendanceList avatar={item.item.avatar} refNavigation={this.props.navigation} isRefresh={this.state.isRefresh} refresh={item.item.refresh} type={item.item.key}  data={item.item.feed} />
                        }else{
                            return <View style={{width:width,height:height,justifyContent:"center",alignItems:"center"}}><Text style={{color : this.props.theme.colors.tertiary.black1.value,fontFamily:this.props.theme.fonts.text}}>{this.props.t('Aucun élément à afficher')}</Text></View>
                        }
                    }}
                />

                <Tabs style={{top:30}} scrollX={this.state.scrollX} data={this.data} total_width={width}
                      indexActive={this.state.activeTab} onItemPressCallBack={this.setActiveTab} onItemPress={this.onItemPress}/>
                <TendancePopin setTimeParution={this.setTimeParution} timeParution={this.state.timeParution} setModalVisible={this.setModalVisible} modalVisible={this.state.modalVisible}  />
            </View>

        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer,timeParution:state.tendanceReducer.timeParution};
}

export default compose(withTranslation(),connect(mapStateToProps))(TendanceScreen);
